import { trpc } from '@/services/trpc';

export function useMcpIntegrationMutation() {
  const utils = trpc.useUtils();

  const invalidate = async () => utils.mcpIntegrations.findAll.invalidate();

  const create = trpc.mcpIntegrations.create.useMutation({
    onSuccess: invalidate,
  });

  const update = trpc.mcpIntegrations.update.useMutation({
    onSuccess: invalidate,
  });

  const remove = trpc.mcpIntegrations.delete.useMutation({
    onSuccess: invalidate,
  });

  const testConnection = trpc.mcpIntegrations.testConnection.useMutation();

  const syncTools = trpc.mcpIntegrations.syncTools.useMutation({
    onSuccess: invalidate,
  });

  return { create, update, remove, testConnection, syncTools };
}
